/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fun_Aloof_Fish_MopInputs */

const fr_fun_aloof_fish_mop = /** @type {(inputs: Fun_Aloof_Fish_MopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuration mise à jour`)
};

/**

* @param {Fun_Aloof_Fish_MopInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const fun_aloof_fish_mop = /** @type {((inputs?: Fun_Aloof_Fish_MopInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fun_Aloof_Fish_MopInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_fun_aloof_fish_mop(inputs)
});